import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import { useTheme } from 'theming';
import useStyles from './styles';
import clsx from 'clsx';
import { Typography } from '../Typography';
var TextBox = forwardRef(function (_a, ref) {
  var _clsx;

  var _a$customClassName = _a.customClassName,
      customClassName = _a$customClassName === void 0 ? '' : _a$customClassName,
      _a$hasError = _a.hasError,
      hasError = _a$hasError === void 0 ? false : _a$hasError,
      _a$messageError = _a.messageError,
      messageError = _a$messageError === void 0 ? '' : _a$messageError,
      rest = __rest(_a, ["customClassName", "hasError", "messageError"]);

  var theme = useTheme();
  var classes = useStyles({
    theme: theme
  });
  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, classes.textAreaError, hasError), _defineProperty(_clsx, customClassName, customClassName), _clsx));
  return React.createElement(React.Fragment, null, React.createElement("textarea", Object.assign({}, rest, {
    ref: ref,
    className: containerStyle
  })), hasError && React.createElement(Typography, {
    variant: 'content3',
    color: 'danger',
    customClassName: classes.bottomError
  }, messageError));
});
export { TextBox };